@if (isLoader) {
  <bmcore-loader></bmcore-loader>
}

@if (!isLoader) {
  <div class="tariff-block__main">
    <h3 class="common-bmstv-title-3">
      You current subscription plan is {{ getSubscriptionPlan(subscription.subscriptionPlan) }}
    </h3>
    <h3 class="common-bmstv-title-3">Expiration date is {{ subscription.expirationDate | date }}</h3>
    <div class="tariff-block__item">
      <span class="tariff-block__plan common-section-title">PREMIUM</span>
      <span class="tariff-block__plan common-section-title">EXPERT</span>
    </div>
    <div class="tariff-block__item">
      <bmcore-month-select [currentMonthId]="currentMonthId" (changeCurrentMonthIdEvent)="changeCurrentMonth($event)">
      </bmcore-month-select>
      <div class="tariff-block__price">
        <span class="tariff-block__price--old common-section-title"> $ {{ this.premiumPrice?.price?.Item1 }} </span>
        <span class="tariff-block__price--current common-section-title">
          $ {{ this.premiumPrice?.couponDiscount?.Item2 }}
        </span>
        <span class="tariff-block__price--discount common-section-title">
          Discount: $
          {{ this.premiumPrice?.price?.Item1 - this.premiumPrice?.couponDiscount?.Item2 }}
        </span>
      </div>
      <div class="tariff-block__price">
        <span class="tariff-block__price--old common-section-title"> $ {{ this.expertPrice?.price?.Item1 }} </span>
        <span class="tariff-block__price--current common-section-title">
          $ {{ this.expertPrice?.couponDiscount?.Item2 }}
        </span>
        <span class="tariff-block__price--discount common-section-title">
          Discount: $
          {{ this.expertPrice?.price?.Item1 - this.expertPrice?.couponDiscount?.Item2 }}
        </span>
      </div>
    </div>
    <div class="tariff-block__item">
      <h3 class="tariff-block__title">FEATURES</h3>
    </div>
    @for (feature of features; track feature) {
      <bmcore-tariff-feature [feature]="feature"> </bmcore-tariff-feature>
    }
    <div class="tariff-block__buttons">
      <div class="tariff-block__button">
        <bmcore-button
          title="Select"
          [styleName]="'center'"
          [disabled]="isSelectButtonsDisabled"
          (clickHandler)="selectPlan('premium')"
        >
        </bmcore-button>
      </div>
      <div class="tariff-block__button">
        <bmcore-button
          title="Select"
          [styleName]="'center'"
          [disabled]="isSelectButtonsDisabled"
          (clickHandler)="selectPlan('expert')"
        >
        </bmcore-button>
      </div>
    </div>
  </div>
}
